module.exports = __webpack_public_path__ + "img/478.e787ee41.jpg";